/*
  lp-card-actions.js
  ------------------
  Added to fix two reported issues on impjaroutlet.com:

    * Quick Add (+) button on collection cards did nothing
    * Header cart count / total did not update after an add

  Previously the button carried only an inline
  `onclick="event.preventDefault(); event.stopPropagation();"` with no handler
  behind it, so it cancelled the card link and then stopped.

  Uses event delegation, so cards appended by the collection page's infinite
  scroll are picked up automatically with no re-binding.
*/
(function () {
  'use strict';

  /* ---------------------------------------------------------------- money */

  // Mirrors Shopify's money_format tokens. Format string comes from the
  // data-money-format attribute rendered by lp-header.liquid.
  function formatMoney(cents, format) {
    if (!format) return '';
    var value = (cents || 0) / 100;

    function withDelimiters(number, precision, thousands, decimal) {
      number = number.toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + thousands);
      var fraction = parts[1] ? decimal + parts[1] : '';
      return whole + fraction;
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_match, token) {
      switch (token) {
        case 'amount':
          return withDelimiters(value, 2, ',', '.');
        case 'amount_no_decimals':
          return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(value, 0, '.', ',');
        case 'amount_with_space_separator':
          return withDelimiters(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return withDelimiters(value, 0, ' ', ',');
        default:
          return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ----------------------------------------------------------- header cart */

  function refreshHeaderCart() {
    return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('[data-lp-cart-count]');
        if (badge) {
          badge.textContent = cart.item_count;
          if (cart.item_count > 0) {
            badge.removeAttribute('hidden');
          } else {
            badge.setAttribute('hidden', '');
          }
        }

        var totalEl = document.querySelector('[data-lp-cart-total]');
        if (totalEl) {
          var formatted = formatMoney(cart.total_price, totalEl.getAttribute('data-money-format'));
          if (formatted) totalEl.textContent = formatted;
        }

        var link = document.querySelector('[data-lp-cart-link]');
        if (link) {
          link.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
        }

        // Let any other cart UI on the page (drawer, cart page) react too.
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart, bubbles: true }));
        return cart;
      })
      .catch(function () { /* leave the server-rendered values in place */ });
  }

  /* -------------------------------------------------------------- quick add */

  function quickAdd(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.classList.contains('is-busy')) return;

    button.classList.add('is-busy');

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function () {
        return refreshHeaderCart();
      })
      .then(function () {
        button.classList.remove('is-busy');
        button.classList.add('is-done');
        setTimeout(function () { button.classList.remove('is-done'); }, 1200);
      })
      .catch(function () {
        button.classList.remove('is-busy');
        // Fall back to the product page so the customer is never stuck.
        var card = button.closest('.lp-product');
        if (card && card.href) window.location.href = card.href;
      });
  }

  /* --------------------------------------------------------------- bindings */

  // Horizon's own product form, cart drawer and quick-add components all
  // dispatch 'cart:update' (see assets/events.js) after changing the cart.
  // Listening here keeps the custom header in sync with adds made anywhere
  // outside this file — the product page "Add to cart" button in particular.
  var refreshQueued = false;
  document.addEventListener('cart:update', function () {
    if (refreshQueued) return;
    refreshQueued = true;
    // Let the dispatching component finish its own work first.
    setTimeout(function () {
      refreshQueued = false;
      refreshHeaderCart();
    }, 0);
  });

  // Browser back/forward can restore a stale header from bfcache.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshHeaderCart();
  });

  document.addEventListener('click', function (event) {
    var addBtn = event.target.closest('[data-lp-quick-add]');
    if (!addBtn) return;

    // The whole card is an <a>; stop it navigating.
    event.preventDefault();
    event.stopPropagation();
    quickAdd(addBtn);
  });
})();
